import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from '@/img/icons/star.svg';
import { addUtmDataToUrl } from 'arbitrip-common/client/utils/UtmUtils';

const ISRACARD_LOBBY_URL = 'https://i.isracard.co.il/mO86/p9k7ag5i';

const IsracardPromotionBar = () => {
    const { t } = useTranslation();

    return (
        <div className="isracard-promotion-bar" data-testid="isracard-promotion-bar">
            <div className="isracard-promotion-bar-inner">
                <StarIcon />

                <span>
                    <span> {t('IsracardBanner.Description')}</span>

                    <a
                        href={addUtmDataToUrl(ISRACARD_LOBBY_URL)}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: 'underline' }}
                    >
                        {t('IsracardBanner.Join')}
                    </a>
                </span>
            </div>
        </div>
    );
};

export default IsracardPromotionBar;
